import ENV from '../constants/envConstants';
import axios from "../axiosConfig";


export const createPlace = (data) => {
    const { values } = data;
    return axios.post(ENV.BACKEND_URL + "/restaurants/places/", values);
}

export const updatePlace = (data) => {
    const { values, placeId } = data;
    return axios.put(ENV.BACKEND_URL + "/restaurants/places/" + placeId + "/", values);
}

export const createMenu = (data) => {
  const { values } = data;
  return axios.post(ENV.BACKEND_URL + "/restaurants/menus/", values);
}

export const updateMenu = (data) => {
  const { values, menuId } = data;
  return axios.put(ENV.BACKEND_URL + "/restaurants/menus/" + menuId + "/", values);
}

export const updateMenuOrder = (data) => {
  const { values, menuId } = data;
  return axios.put(ENV.BACKEND_URL + "/restaurants/menus/" + menuId + "/reorder/", values);
}

export const updatePlaceMenuOrder = (data) => {
  const { values, placeId } = data;
  return axios.put(ENV.BACKEND_URL + "/restaurants/places/" + placeId + "/reorder-menus/", values);
};

export const updateMenuCategoryOrder = (data) => {
  const { values, menuCategoryId } = data;
  return axios.put(ENV.BACKEND_URL + "/restaurants/menu-categories/" + menuCategoryId + "/reorder/", values);
}

export const addApprovalRequest = (data) => {
  const { placeId } = data;
  return axios.put(ENV.BACKEND_URL + "/restaurants/places/" + placeId + "/approval-request/", { place: placeId });
}

export const addDish = (data) => {
  const { values, categoryId } = data;
  return axios.post(ENV.BACKEND_URL + "/restaurants/menu-categories/" + categoryId + "/add-dish/", values);
}

export const editDish = (data) => {
  const { values, dishId } = data;
  return axios.put(ENV.BACKEND_URL + "/restaurants/dishes/" + dishId + "/", values);
};

export const editCategoryDish = (data) => {
  const { values, categoryDishId } = data;
  return axios.put(ENV.BACKEND_URL + "/restaurants/dishes/category-dish/" + categoryDishId + "/", values);
};

export const uploadPdfMenu = data => {
    const { placeId, values } = data;
    return axios.put(ENV.BACKEND_URL + "/restaurants/places/" + placeId + "/upload-pdf-menu/", values);
}

export const removeMenu = (data) => {
    const { menuId } = data;
    return axios.delete(ENV.BACKEND_URL + "/restaurants/menus/" + menuId + "/");
  };

export const createSection = (data) => {
    const { values } = data;
    return axios.post(ENV.BACKEND_URL + "/restaurants/menu-categories/", values);
  };

export const updateSection = (data) => {
    const { values, sectionId } = data;
    return axios.put(ENV.BACKEND_URL + "/restaurants/menu-categories/" + sectionId + "/", values);
};

export const menuPublished = (data) => {
  const { placeId } = data;
  return axios.put(ENV.BACKEND_URL + "/restaurants/places/" + placeId + "/published/", {});
}
